var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHaircut = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21 10h4V4h-2v2h-2V4h-2v2h-2V4h-2v2h-2V4h-2v2H9V4H7v6h4v-.5A1.5 1.5 0 0 1 12.5 8h7A1.5 1.5 0 0 1 21 9.5zm0 2v3a5 5 0 0 1-10 0v-3H9v11a7 7 0 1 0 14 0V12zm2-10h2.5A1.5 1.5 0 0 1 27 3.5v7a1.5 1.5 0 0 1-1.5 1.5H25v11a9 9 0 1 1-18 0V12h-.5A1.5 1.5 0 0 1 5 10.5v-7A1.5 1.5 0 0 1 6.5 2H9V0h2v2h2V0h2v2h2V0h2v2h2V0h2zm-10 8v5a3 3 0 1 0 6 0v-5zm3 12a2 2 0 0 1 2 2v2a2 2 0 1 1-4 0v-2a2 2 0 0 1 2-2"
})));
export default SvgHaircut;